import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { BlueOcean } from '../../../../shared/models/blueocean-product';
import { PowerBiApi } from '../../models/power-bi-models';
import { ApplicationState } from '../../../../shared/state/application-state.service';
import { PowerBiState } from '../../state/power-bi-state.service';

@Component({
  selector: 'app-report-card',
  imports: [],
  templateUrl: './report-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportCardComponent implements OnInit {
  
  report = input.required<PowerBiApi.Report>();
  product = input.required<BlueOcean.Product | null>();

  applicationStateService = inject(ApplicationState);
  powerbiState = inject(PowerBiState);
  router = inject(Router);

  constructor() { }

  ngOnInit(): void { }

  setActiveReport() {
    this.powerbiState.selectReport(this.report()?.id ?? null);
    this.router.navigate(['report']);
  }

  goToProductInfo(event: Event) {
    event.stopPropagation();
    if (this.product) {
      this.router.navigate(['/product', this.product()?.shortName]);
    }
  }

  get isReleaseCandidate(): boolean {
    return this.report()?.name.toLowerCase().includes('-rc');
  }

}
